module.exports = __webpack_public_path__ + "img/NissanLeafInvertor.e2c0eecf.jpeg";